import {
  iconButtonBlack,
  iconButtonWhiteText,
  iconButtonBlackText,
  iconButtonWhite,
} from "../../assets/styles/helpers/colors.styles";

import { IconButtonProps } from "./IconButton";

export const getIconButtonStyles = (
  color: IconButtonProps["color"],
  variant: IconButtonProps["variant"]
) => {
  switch (variant) {
    case "contained":
      switch (color) {
        case "primary":
          return {
            backgroundColor: iconButtonWhite.background,
            border: "none",
            color: iconButtonWhite.font,
            "&:hover": {
              background: iconButtonWhite.backgroundHover,
            },
            "&:active": {
              background: iconButtonWhite.backgroundActive,
            },
          };
        case "secondary":
          return {
            backgroundColor: iconButtonBlack.background,
            border: "none",
            color: iconButtonBlack.font,
            "&:hover": {
              background: iconButtonBlack.backgroundHover,
            },
            "&:active": {
              background: iconButtonBlack.backgroundActive,
            },
          };
        default:
          return {
            backgroundColor: iconButtonWhite.background,
            border: "none",
            color: iconButtonWhite.font,
            "&:hover": {
              background: iconButtonWhite.backgroundHover,
            },
            "&:active": {
              background: iconButtonWhite.backgroundActive,
            },
          };
      }
    case "text":
      switch (color) {
        case "primary":
          return {
            backgroundColor: iconButtonWhiteText.background,
            border: "none",
            color: iconButtonWhiteText.font,
            "&:hover": {
              color: iconButtonWhiteText.fontHover,
            },
            "&:active": {
              color: iconButtonWhiteText.fontActive,
            },
          };
        case "secondary":
          return {
            backgroundColor: iconButtonBlackText.background,
            border: "none",
            color: iconButtonBlackText.font,
            "&:hover": {
              color: iconButtonBlackText.fontHover,
            },
            "&:active": {
              color: iconButtonBlackText.fontActive,
            },
          };
        default:
          return {
            backgroundColor: iconButtonWhiteText.background,
            border: "none",
            color: iconButtonWhiteText.font,
            "&:hover": {
              color: iconButtonWhiteText.fontHover,
            },
            "&:active": {
              color: iconButtonWhiteText.fontActive,
            },
          };
      }
  }
};
